/**
 * Height / width of the whole `react-device-mockup` frame (screen + bezel),
 * measured by rendering the lib at screenWidth 200 and 300 (island iPhone:
 * 443/214 and 664/320; Android: 443/213 and 666/320).
 */
export const IPHONE_FRAME_ASPECT = 2.07;
export const ANDROID_FRAME_ASPECT = 2.08;

/** Screen width / total frame width (300 / 320 at screenWidth 300). */
const SCREEN_TO_FRAME_WIDTH = 0.9375;

export function fitScreenWidth(input: {
  containerWidth: number;
  containerHeight: number;
  frameAspect: number;
  padding: number;
  min: number;
  max: number;
}): number {
  const availableWidth = input.containerWidth - input.padding * 2;
  const availableHeight = input.containerHeight - input.padding * 2;
  const frameWidth = Math.min(
    availableWidth,
    availableHeight / input.frameAspect
  );
  const screenWidth = Math.floor(frameWidth * SCREEN_TO_FRAME_WIDTH);
  return Math.min(input.max, Math.max(input.min, screenWidth));
}
